export default "__VITE_ASSET__CywlJrrm__"